import { render } from "./AddGuideReviewModal.vue?vue&type=template&id=067bf27c"
import script from "./AddGuideReviewModal.vue?vue&type=script&lang=js"
export * from "./AddGuideReviewModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__